import { jsPDF } from 'jspdf';
import PptxGenJS from 'pptxgenjs';

export function getBackgroundImageVariation(
  backgroundImage: string | Record<string, string>,
  slideIndex: number,
  totalContentSlides: number,
): string {
  if (typeof backgroundImage === 'string') {
    return backgroundImage;
  }

  if (backgroundImage && typeof backgroundImage === 'object') {
    const variationKeys = Object.keys(backgroundImage);
    const totalVariations = variationKeys.length;

    if (totalVariations > 0) {
      const variationIndex = Math.floor(
        (slideIndex / totalContentSlides) * totalVariations,
      );
      const key = variationKeys[Math.min(variationIndex, totalVariations - 1)];
      return backgroundImage[key] ?? '';
    }
  }

  return '';
}

export function setBackground(
  element: PptxGenJS.Slide | jsPDF,
  backgroundImage: string | undefined,
  backgroundColor: string | undefined,
  isPptx = true,
): void {
  if (backgroundImage) {
    try {
      if (typeof backgroundImage !== 'string' || backgroundImage.trim() === '') {
        throw new Error('Invalid background image path');
      }
      
      if (isPptx) {
        (element as PptxGenJS.Slide).background = { path: backgroundImage };
      } else {
        try {
          (element as jsPDF).addImage(backgroundImage, 'PNG', 0, 0, 10, 5.63);
        } catch (imageError) {
          console.error('Failed to add image to PDF:', imageError);
          if (backgroundColor) {
            (element as jsPDF).setFillColor(backgroundColor.slice(1));
            (element as jsPDF).rect(0, 0, 10, 5.63, 'F');
          }
        }
      }
    } catch (error) {
      console.error('Background image error:', error);
      if (backgroundColor) {
        if (isPptx) {
          (element as PptxGenJS.Slide).background = { color: backgroundColor.slice(1) };
        } else {
          (element as jsPDF).setFillColor(backgroundColor.slice(1));
          (element as jsPDF).rect(0, 0, 10, 5.63, 'F');
        }
      }
    }
  } else if (backgroundColor) {
    if (isPptx) {
      (element as PptxGenJS.Slide).background = { color: backgroundColor.slice(1) };
    } else {
      (element as jsPDF).setFillColor(backgroundColor.slice(1));
      (element as jsPDF).rect(0, 0, 10, 5.63, 'F');
    }
  }
}

export function isTitleLong(title: string, threshold: number): boolean {
  return title.length > threshold || title.includes('\n');
}